import { render, staticRenderFns } from "./bygz_banner.vue?vue&type=template&id=63c12fad&scoped=true&"
import script from "./bygz_banner.vue?vue&type=script&lang=js&"
export * from "./bygz_banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c12fad",
  null
  
)

export default component.exports